import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23d86800"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background-color":"#ffffff"} }
const _hoisted_2 = { class: "inquiry-right-div" }
const _hoisted_3 = { style: {"margin-left":"1%"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inquiry-header-remark" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-left":"15px","justify-content":"center","margin-top":"13px"} }, " You can send the registration page to new user. Please enter the new user's email address. ")
], -1 /* HOISTED */))
const _hoisted_5 = { class: "search-div margin-top-20" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-left-div" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-5" }, "Email address:")
], -1 /* HOISTED */))
const _hoisted_7 = { class: "search-right-div" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "search-div margin-top-20" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-left-div" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-5" }, "re-enter Email address:")
], -1 /* HOISTED */))
const _hoisted_11 = { class: "search-right-div" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "search-div margin-top-20"
}
const _hoisted_15 = {
  key: 1,
  class: "search-div margin-top-20"
}
const _hoisted_16 = { class: "search-left-div" }
const _hoisted_17 = { class: "search-right-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Navigation"]),
    _createVNode($setup["InquiryNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _createVNode($setup["InquiryLinkNavigation"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["Alert"], {
          alertMessage: $setup.alertMessage,
          alertState: $setup.alertState
        }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            class: "txtSearch",
            type: "email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event)),
            placeholder: "example@example.com",
            disabled: $setup.confirmEmail!=''
          }, null, 8 /* PROPS */, _hoisted_8), [
            [_vModelText, $setup.email]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            class: "txtSearch",
            type: "email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.reEmail) = $event)),
            placeholder: "example@example.com",
            disabled: $setup.confirmEmail!=''
          }, null, 8 /* PROPS */, _hoisted_12), [
            [_vModelText, $setup.reEmail]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btnGo",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.sendEmail())),
            disabled: $setup.email != $setup.reEmail || $setup.email == '' || $setup.message !== ''
          }, " Send mail ", 8 /* PROPS */, _hoisted_13)
        ])
      ]),
      ($setup.message !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("h4", null, _toDisplayString($setup.message), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.message !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btnGo",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.sendCheckedEmail()))
              }, " YES ")
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btnGo",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.cancel()))
              }, " NO ")
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}